import { CMS_Content_Module_VideoGalleryData } from './types';
import { VideoGalleryElement } from './video-gallery-element';
import { Slider } from '@cue/organisms';
import React, { useMemo, useState } from 'react';

export const VideoGallery: React.FC<VideoGalleryProps> = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { videos, player_type = 'VideoGallery' } = props;

  const currentDescription = useMemo(
    () => videos?.[currentSlide]?.description || '',
    [videos, currentSlide],
  );

  const curentPosition = useMemo(
    () =>
      (
        <>
          <strong>{currentSlide + 1}</strong> / {videos.length}
        </>
      ) || '',
    [videos, currentSlide],
  );

  const slider = useMemo(
    () => (
      <Slider
        className="cue-grid-slider cue-video-gallery"
        spaceBetween={10}
        effect={'coverflow'}
        slidesPerView={1.05}
        pagination={{ enabled: false }}
        coverflowEffect={{
          rotate: 20,
          stretch: 0,
          depth: 1,
          modifier: 1,
          slideShadows: true,
        }}>
        {videos.map((video, index) => (
          <VideoGalleryElement
            {...video}
            index={index}
            key={video.id}
            player_type={player_type}
            onCurrentSlide={(index) => setCurrentSlide(index)}
          />
        ))}
      </Slider>
    ),
    [videos, player_type],
  );

  return (
    <>
      {slider}
      <div className="cue-video-gallery-info">
        <div>
          <div className="cue-video-gallery-info-position">{curentPosition}</div>
          <div className="cue-video-gallery-info-description">{currentDescription}</div>
        </div>
      </div>
    </>
  );
};
export type VideoGalleryProps = CMS_Content_Module_VideoGalleryData;
{
  /* <Slider
      className="cue-grid-slider"
      spaceBetween={10}
      breakpoints={{
        768: {
          slidesPerView: 2,
        },
        1100: {
          slidesPerView: 3,
        },
      }}>
      {children}
    </Slider> */
}
